// Import all FAQ components
import WelcomeFaq from "./welcome.vue";
import AdsFaq from "./ads.vue";
import BehaviorFaq from "./behavior.vue";
import BusinessFaq from "./business.vue";
import CreditsFaq from "./credits.vue";
import EmbeddingFaq from "./embedding.vue";
import HowToFaq from "./howTo.vue";
import RandomnessFaq from "./randomness.vue";
import SoundFaq from "./sound.vue";
import MaintainerFaq from "./maintainer.vue";
import FundingFaq from "./funding.vue";
import FeedbackFaq from "./feedback.vue";
import PrivacySummaryFaq from "./privacy-summary.vue";

// Export individually
export {
  WelcomeFaq,
  AdsFaq,
  BehaviorFaq,
  BusinessFaq,
  CreditsFaq,
  EmbeddingFaq,
  HowToFaq,
  RandomnessFaq,
  SoundFaq,
  MaintainerFaq,
  FundingFaq,
  FeedbackFaq,
  PrivacySummaryFaq,
};

// Export map for dynamic component loading
export const faqComponents = {
  welcome: WelcomeFaq,
  ads: AdsFaq,
  behavior: BehaviorFaq,
  business: BusinessFaq,
  credits: CreditsFaq,
  embedding: EmbeddingFaq,
  "how-to": HowToFaq,
  randomness: RandomnessFaq,
  sound: SoundFaq,
  maintainer: MaintainerFaq,
  funding: FundingFaq,
  feedback: FeedbackFaq,
  "privacy-summary": PrivacySummaryFaq,
};
